"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BasicCamera_1 = require('./BasicCamera');
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
var Camera_1 = require('../../cameras/Camera');
var _scratch1 = [0, 0, 0];
var FpsCamera = (function (_super) {
    __extends(FpsCamera, _super);
    function FpsCamera(player, opts) {
        if (opts === void 0) { opts = {}; }
        var fov = 45;
        var near = 0.1;
        var far = 200;
        _super.call(this, fov, near, far);
        this.enableFlight = opts.enableFlight !== undefined ? opts.enableFlight : true;
        this.camera = new BasicCamera_1.default(player);
    }
    FpsCamera.prototype.resizeViewport = function (width, height) {
        mat4.perspective(this.projectionMatrix, this.fov * Math.PI / 180, width / height, this.near, this.far);
    };
    FpsCamera.prototype.update = function () {
        this.camera.view(this.viewMatrix);
    };
    FpsCamera.prototype.getPosition = function (out) {
        mat4.getTranslation(out, this.camera.modelMatrix);
    };
    ;
    FpsCamera.prototype.getVector = function (out) {
        this.camera.getCameraVector(_scratch1);
        out[0] = -_scratch1[0];
        out[1] = -_scratch1[1];
        out[2] = -_scratch1[2];
    };
    ;
    return FpsCamera;
}(Camera_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FpsCamera;
//# sourceMappingURL=FpsCamera.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/cameras/FpsCamera/FpsCamera.js
 ** module id = 922
 ** module chunks = 0
 **/